// extracted by mini-css-extract-plugin
export default {"image":"UX-z","loaded":"VX-z"};